export default {
  // 账号: 纯数字或纯字母或数字与字符组合，长度不可超过20
  account (rule, value, callback) {
    if (!/^[0-9a-zA-Z]*$/g.test(value)) {
      callback('请输入纯数字/纯字母/数字与字符组合')
    }
    callback()
  },

  // 邮件
  email (rule, value, callback) {
    if (!value || value.length === 0) {
      callback()
    }
    if (!/^([a-zA-Z]|[0-9])(\w|[-])+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value)) {
      callback('请输入正确的邮箱格式')
    }
    callback()
  },

  // 手机号
  phone (rule, value, callback) {
    if (!/^1\d{10}$/.test(value)) {
      callback('请输入正确的手机格式')
    }
    callback()
  },

  // 条形码
  barCode (rule, value, callback) {
    if (!/^[\d\w]{6,20}?$/.test(value)) {
      return callback(new Error('请输入6-20个数字或字母'))
    }
    return callback()
  },

  // 商品码
  productCode (rule, value, callback) {
    if (!/^[\d\w]{2,50}$/.test(value)) {
      return callback(new Error('请输入2-50个数字或字母'))
    }
    return callback()
  },

  // 客服电话
  consumerHotline (rule, value, callback) {
    if (!/^[0-9]+$/.test(value)) {
      return callback(new Error('请输入正确的客服电话'))
    }
    return callback()
  },

  // 特殊字符
  specialCharacter (rule, value, callback) {
    var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
    if (pattern.test(value)) {
      return callback(new Error('请不要输入特殊字符'))
    }
    return callback()
  },

  // 描述
  desc (rule, value, callback) {
    if (!/^.{0,100}$/.test(value)) {
      callback(new Error('长度不能超过100个字符'))
    }
    callback()
  },

  // 长度
  length (rule, value, callback) {
    if (rule.length && (value.toString() > rule.length)) {
      callback(new Error(rule.message || '长度不能超过' + rule.length + '个字符'))
    }
    callback()
  },

  // 必填
  required (rule, value, callback) {
    if (!rule.noRequired && (value === null || value === undefined || value.length === 0)) {
      callback(new Error('输入不能为空'))
    }
    callback()
  },

  // 正整数
  positiveInteger (rule, value, callback) {
    if (value === 0 || value === '0') {
      callback(new Error('请输入正整数'))
    }
    if (value && (!value || (value.length !== 0 && (!/^\d{0,}$/.test(value)) || parseFloat(value) === '0'))) {
      callback(new Error('请输入正整数'))
    }
    callback()
  },

  // 包含0和正整数
  zeroPositiveInteger (rule, value, callback) {
    if (value === 0 || value === '0') {
      callback()
    }
    if (value && (!value || (value.length !== 0 && (!/^\d{0,}$/.test(value)) || parseFloat(value) === '0'))) {
      callback(new Error('请输入0或正整数'))
    }
    callback()
  },

  // 正浮点数
  positiveFloat (rule, value, callback) {
    if (value && (value.length !== 0 && (!/^\d+(\.\d+)?$/.test(value) || parseFloat(value) === '0'))) {
      callback(new Error('请输入正浮点数'))
    }
    callback()
  },

  // 判断富文本中是否存在base64图片
  notIncludedBase64 (rule, value, callback) {
    if (value && (value.toString().length !== 0 && /data:image\/(\w{0,5});base64,/ig.test(value))) {
      callback(new Error('不允许复制粘贴图片, 请使用图片上传'))
    }
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/components/mc-ui/validate/index.js